import { render } from "./BopFooter.vue?vue&type=template&id=5ad5f25b&scoped=true"
import script from "./BopFooter.vue?vue&type=script&lang=js"
export * from "./BopFooter.vue?vue&type=script&lang=js"

import "./BopFooter.vue?vue&type=style&index=0&id=5ad5f25b&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad5f25b"]])

export default __exports__